import React, { Component } from "react";
import { connect } from "react-redux";
import { Route, Switch } from "react-router-dom";
import ClockScene from "./scenes/Clock/";
import AdminReports from "./scenes/AdminReports";
import ScheduleView from "./scenes/ScheduleView";
import Schedule from "./scenes/Schedule";
import ClockNew from "./scenes/ClockNew";
import TimeNew from "./scenes/TimeNew";
import ClockEdit from "./scenes/ClockEdit";
import ActiveEmployees from "./scenes/CurrentlyWorking";
import { hasPermission } from "../../reducer";
import { push } from "react-router-redux";


class Clock extends Component {

    componentDidMount(){
        if(!this.props.hasPermission('clock')){
            this.props.redirectNoPermission();
        }
    }

    render() {


            return(
                <Switch>
                    {this.props.hasPermission('clockAdmin') && <Route path={'/clock/admin/newTime'} component={TimeNew}/>}
                    {this.props.hasPermission('clockAdmin') && <Route path={'/clock/admin/newClock'} component={ClockNew}/>}
                    {this.props.hasPermission('clockAdmin') && <Route path={'/clock/admin/reports'} component={AdminReports}/>}
                    {this.props.hasPermission('clock') &&<Route path={'/clock/admin/active'} component={ActiveEmployees}/>}
                    {this.props.hasPermission('clockAdmin') &&<Route path={'/clock/admin/:id'} component={ClockEdit}/>}
                    {this.props.hasPermission('schedule') &&<Route path={"/clock/schedule/view"} component={ScheduleView}/>}
                    {this.props.hasPermission('scheduleManage') &&<Route path={"/clock/schedule"} component={Schedule}/>}
                    {this.props.hasPermission('clock') &&<Route path={'/'} component={ClockScene}/>}
                </Switch>
            );
    }
}

const mapStateToProps = state => ({
    isAdmin: hasPermission(state,'clockAdmin'),
    hasPermission: (permission)=>hasPermission(state,permission)
});

const mapDispatchToProps = (dispatch) => {
    return({
        redirectNoPermission: ()=>(dispatch(push('/settings')))
    });
}

export default  connect(
    mapStateToProps,
    mapDispatchToProps
)(Clock);



// WEBPACK FOOTER //
// ./src/scenes/Clock/index.js